import API from "./axiosConfig";

// Vendor Management Endpoints
export const getVendors = async (params = {}) => {
  return await API.get("/vendors", { params });
};

export const getVendorById = async (id) => {
  return await API.get(`/vendors/${id}`);
};

export const addVendor = async (vendorData) => {
  return await API.post("/vendors", vendorData);
};

export const bulkUploadVendors = async (vendorsData) => {
  return await API.post("/vendors/bulk", vendorsData);
};

export const updateVendor = async (id, vendorData) => {
  return await API.put(`/vendors/${id}`, vendorData);
};

export const deleteVendor = async (id) => {
  return await API.delete(`/vendors/${id}`);
};

export const searchVendors = async (query) => {
  return await API.get("/vendors/search", { params: { q: query } });
};

export const getVendorStats = async () => {
  return await API.get("/vendors/stats");
};

// Vendor Status Update
export const updateVendorStatus = async (id, status) => {
  return await API.patch(`/vendors/${id}/status`, { status });
};

// Document Management Endpoints
export const addVendorDocument = async (id, documentData) => {
  return await API.post(`/vendors/${id}/documents`, documentData);
};

export const getVendorDocuments = async (id) => {
  return await API.get(`/vendors/${id}/documents`);
};

export const removeVendorDocument = async (vendorId, docId) => {
  return await API.delete(`/vendors/${vendorId}/documents/${docId}`);
};

// New Performance Management Endpoints
export const addVendorPerformance = async (vendorId, performanceData) => {
  return await API.post(`/vendors/${vendorId}/performance`, performanceData);
};

export const removeVendorPerformance = async (vendorId, performanceId) => {
  return await API.delete(`/vendors/${vendorId}/performance/${performanceId}`);
};

// New Contract Management Endpoints
export const addVendorContract = async (vendorId, contractData) => {
  return await API.post(`/vendors/${vendorId}/contracts`, contractData);
};

export const bulkUploadContracts = async (contractsData) => {
  return await API.post("/vendors/contracts/bulk", contractsData);
};

export const removeVendorContract = async (vendorId, contractId) => {
  return await API.delete(`/vendors/${vendorId}/contracts/${contractId}`);
};

export const updateVendorContract = async (vendorId, contractId, contractData) => {
  return await API.put(`/vendors/${vendorId}/contracts/${contractId}`, contractData);
};
